<template>
  <div :class="{'item-error': item.error}" class="item-paragraph">
    <b-card class="item-card">
      <options :item="item" :level="level"/>

      <h2 class="item-title">Paragraph</h2>
      <wysiwyg
        :class="{ 'is-invalid' : item.apiErrors && item.apiErrors.length, 'disabled' : saving || fetching }"
        v-model="item.text"/>
      <validation-errors :validation-errors="item.apiErrors"/>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import options from './options'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    options,
    validationErrors
  },
  props: {
    id: {
      type: String,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('items', [
      'saving',
      'fetching'
    ]),
    item () {
      return this.$store.getters['items/byID']({id: this.id})
    },
    text () {
      return this.item.text
    }
  },
  watch: {
    text (newText, oldText) {
      if (this.item.apiErrors && this.item.apiErrors.length) {
        this.$store.commit('items/setProps', {
          id: this.item.id,
          props: {
            apiErrors: []
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/paragraph.vue